import {
  requiredString,
  optionalString,
  optionalBoolean,
  createResourceSchema
} from './common'

export const capabilitySchema = createResourceSchema({
  name: requiredString('Name'),
  icon: optionalString,
  description: optionalString,
  active: optionalBoolean
})
